var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"box"},[_c('h1',[_vm._v("Web通用渠道追踪测试")]),_c('button',{on:{"click":_vm.but}},[_vm._v("点击事件")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }